import { useId } from 'react'
import { Input } from '../catalyst/input'

/**
 * Free-text input for a building, facility, equipment or trap name, suggesting names already used on
 * this farm so the same thing keeps the same name (there's no registry until Form A exists).
 */
export function NameInput({ suggestions, ...props }: { suggestions: string[] } & React.ComponentPropsWithoutRef<typeof Input>) {
  const listId = useId()
  return (
    <>
      <Input list={listId} autoComplete="off" {...props} />
      <datalist id={listId}>
        {suggestions.map((name) => (
          <option key={name} value={name} />
        ))}
      </datalist>
    </>
  )
}
